<template>
  <div v-if="efectorlogueado">
    <v-card>
      <v-card-title>
        Buscar
        <v-spacer></v-spacer>
        <autocompletar v-model="buscado"></autocompletar>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text v-if="buscado">
        <v-row :class="{ green: deAlta && !strPlanInvalido, red: !deAlta || strPlanInvalido }" class="lighten-2">
          <v-col cols="3" md="12">
            <h3 v-if="deAlta">Afiliado de Alta</h3>
            <h3 v-if="!deAlta">Afiliado de Baja{{ strBaja }}</h3>
            <h3 v-if="strPlanInvalido">{{ strPlanInvalido }}</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="1">
            <v-text-field
              filled
              readonly
              hide-details
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="afiparent"
              label="Nro.Afiliado"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              filled
              readonly
              hide-details
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="buscado.apellido_y_nombre"
              label="Nombre"
            ></v-text-field>
          </v-col>
          <v-col cols="5" md="2">
            <v-text-field
              filled
              readonly
              hide-details
              placeholder=" "
              outlined
              class="upperText"
              dense
              v-model="buscado.nro_doc"
              label="Nro.documento"
            ></v-text-field>
          </v-col>
          <v-col cols="7" md="2">
            <cboPlan class="white" readonly v-model="buscado.id_plan"></cboPlan>
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              filled
              readonly
              hide-details
              placeholder=" "
              outlined
              type="date"
              class="upperText"
              dense
              v-model="buscado.fecha_nacimiento"
              label="Fecha Nacimiento"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import autocompletar from '@/components/Beneficiarios/AutoNombreDNINroAfi'
import cboPlan from '@/components/Planes/Combo'

import { mapActions, mapState } from 'vuex'
import API from '../../../lib/API'
import LUM from '../../../lib/LUM'
export default {
  components: {
    autocompletar,
    cboPlan,
  },
  data() {
    return {
      buscado: undefined,
    }
  },
  computed: {
    ...mapState('micrositioefectores', ['Usuario']),
    ...mapState('efectores', { efectorlogueado: 'Seleccionado' }),
    hoy() {
      return LUM.datetoYYYYMMDD(new Date())
    },
    deAlta() {
      let ret =
        (!this.buscado.fecha_baja || this.buscado.fecha_baja > this.hoy) &&
        this.buscado.fecha_alta <= this.hoy
      return ret
    },
    strBaja() {
      let ret = ''
      if (this.buscado.fecha_baja && this.buscado.fecha_baja < this.hoy) {
        ret = ' desde el ' + LUM.datetoDDMMYYYY(this.buscado.fecha_baja)
      }
      if (this.buscado.fecha_alta > this.hoy) {
        ret =
          '. Estará de alta a partir del ' +
          LUM.datetoDDMMYYYY(this.buscado.fecha_alta)
      }
      return ret
    },
    strPlanInvalido() {
      let planes = process.env.VUE_APP_PLANES_EFECTOR_EXTERNO.split(',')
      let ret = ''
      if (this.buscado.id_plan) {
        let plan = planes.find((p) => p == this.buscado.id_plan)
        if (!plan) {
          ret =
            'Afiliado con plan no alcanzado para este efector. NO ATENDER!!!'
        }
      }
      return ret
    },
    afiparent() {
      let ret = ''
      if (this.buscado) {
        ret = this.buscado.nro_afi + '/' + this.buscado.parent
      }
      return ret
    },
  },
  methods: {
    ...mapActions('efectores', { SeleccionarEfector: 'select' }),
    ...mapActions('micrositioefectores', ['inicializar']),
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar()
      if (!this.Usuario) {
        this.$router.push({ name: 'Micrositio' })
      }
    }
    if (this.Usuario && !this.efectorlogueado) {
      let efector = await API.Efector.traerUno(this.Usuario.UserId)
      this.SeleccionarEfector(efector)
    }
  },
}
</script>

<style></style>
